// extracted by mini-css-extract-plugin
export default {"card":"Card_card__UZ-pA","card_header":"Card_card_header__BmDj8","title":"Card_title__u3kJK"};